export const getHashFromLandingPage = (loginInfo) => {
  const _hashMap = {
    ASSET_LIST: "/tracked_assets",
    ASSET_MAP: "/assets_location",
    GEOZONE_DASHBOARD: "/geozones_dashboard",
    ACTIVE_ALERT_DASHBOARD: "/active_alerts_dashboard",
    REPORTS: "/reports",
    ORGANISATIONS: "/organization",
    TRACKER_ADMIN: "/trackers_admin",
    SUEZ_DASHBOARD: "/suez_dashboard",
    DASHBOARD: "/bi_dashboard/",
  };

  if (loginInfo.landingPage && loginInfo.landingPage.page === "DASHBOARD") {
    let appliedFilterSettings = loginInfo.landingPage.appliedFilterSettings;
    if (typeof loginInfo.landingPage.appliedFilterSettings == "string") {
      appliedFilterSettings = JSON.parse(
        loginInfo.landingPage.appliedFilterSettings
      );
    }
    return _hashMap["DASHBOARD"] + appliedFilterSettings.dashboardId;
  }

  if (
    loginInfo.userPermissions &&
    loginInfo.userPermissions.includes("MANUFACTURING")
  ) {
    return "/manufacturing_info_view";
  } else if (loginInfo.landingPage && loginInfo.landingPage.page) {
    return _hashMap[loginInfo.landingPage.page];
  } else if (
    loginInfo.organisation &&
    loginInfo.organisation.organisationType === "PARTNER"
  ) {
    return "/organization";
  } else {
    return "/tracked_assets";
  }
};
